import { graphql } from "../gql";

export const sendClaimReportsToClientMutationDoc = graphql(`
  mutation sendClaimReportsToClient($input: ClaimReportTransferInput!) {
    sendClaimReportsToClient(input: $input) {
      __typename
      id
    }
  }
`);
